import { useFetch, useMutation, buildUrl } from './useApi';
import { ADMIN_API_BASE_URL } from '../config';
import { getAuthToken } from './useAdminRefactored';
import type { ApiResponse } from './types';

function getAuthHeaders(): Record<string, string> {
  const token = getAuthToken();
  // return token ? { Authorization: `Bearer ${token}` } : {};
  return {};
}

export interface SMSSettings {
  id?: number;
  apiUsername: string;
  apiPassword: string;
  description: string;
  provider: string;
  createdBy?: string;
  createdDate?: string;
  isDeletedValue?: boolean;
  modifiedBy?: string;
  modifiedDate?: string;
}

export interface UpdateSMSSettingsRequest {
  id?: number;
  apiUsername: string;
  apiPassword: string;
  description: string;
  provider: string;
}

export function useSMSSettings(
  options: {
    enabled?: boolean;
    onSuccess?: (data: SMSSettings) => void;
    onError?: (error: Error) => void;
  } = {}
) {
  const url = buildUrl(ADMIN_API_BASE_URL, '/sms-settings/get-sms-setting');

  const response = useFetch<ApiResponse<SMSSettings>>(url, {
    enabled: options.enabled !== false,
    headers: getAuthHeaders(),
    onSuccess: (data) => options.onSuccess?.(data.data),
    onError: options.onError,
  });

  return {
    ...response,
    data: response.data?.data || null,
  };
}

export function useUpdateSMSSettings(
  options: {
    onSuccess?: (data: SMSSettings) => void;
    onError?: (error: Error) => void;
  } = {}
) {
  return useMutation<SMSSettings, UpdateSMSSettingsRequest>(
    async (variables) => {
      const id = variables.id;
      if (!id) {
        throw new Error('SMS Settings ID is required for update');
      }
      const url = buildUrl(ADMIN_API_BASE_URL, `/sms-settings/${id}`);

      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(variables),
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const result: ApiResponse<SMSSettings> = await response.json();
      return result.data;
    },
    {
      onSuccess: (data, variables) => options.onSuccess?.(data),
      onError: (error, variables) => options.onError?.(error),
    }
  );
}
